import { Col, Form, Row } from 'antd';
import { FormField } from 'components';
import get from 'lodash/get';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setValidity, updateFormField } from 'store/forms/actions';
import {
  formFields311,
  formFields312,
  formFields3111,
  formFields3112,
} from './formFields';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import styles from './SubTabPlan1.module.scss';

const SubTabPlan1 = () => {
  const dispatch = useDispatch();
  const excelData = useSelector(
    state => state.forms?.carrier?.dapanesEpendysis
  );
  const [businessPlanDetails, setBusinessPlanDetails] = useState('');
  const carrier = useSelector(state => state.forms.carrier);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);

  useEffect(() => {
    if (excelData) {
      setBusinessPlanDetails(JSON.parse(excelData));
    } else {
      setBusinessPlanDetails('');
    }
  }, [excelData]);

  const [form] = useForm();

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea') {
      newValue = event.target.value;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals' ||
      type === 'formattedNumber'
    ) {
      newValue = event;
    }
    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  const renderFieldValue1 = field => {
    const value = get(businessPlanDetails.ependutikoSxedio, field.name);
    return field.type === 'date'
      ? value
        ? moment(value, 'DD/MM/YYYY')
        : undefined
      : value || undefined;
  };

  const renderFieldValue2 = field => {
    const value = get(businessPlanDetails.toposEkteleshs, field.name);
    return field.type === 'date'
      ? value
        ? moment(value)
        : undefined
      : field.name == 'topos'
      ? value?.toUpperCase()
      : value || undefined;
  };

  useEffect(() => {
    if (businessPlanDetails) {
      formFields311.map(field =>
        form.setFieldValue(field.name, renderFieldValue1(field))
      );
      formFields3111.map(field =>
        form.setFieldValue(field.name, renderFieldValue1(field))
      );
      formFields3112.map(field =>
        form.setFieldValue(field.name, renderFieldValue1(field))
      );
      formFields312.map(field =>
        form.setFieldValue(field.name, renderFieldValue2(field))
      );
    } else {
      formFields311.map(field => form.setFieldValue(field.name, undefined));
      formFields3111.map(field => form.setFieldValue(field.name, undefined));
      formFields3112.map(field => form.setFieldValue(field.name, undefined));
      formFields312.map(field => form.setFieldValue(field.name, undefined));
    }
  }, [businessPlanDetails]);

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  useEffect(() => {
    const field311 = Object.values(formFields311).map(field => field.name);
    const field312 = Object.values(formFields312).map(field => field.name);

    form.validateFields(field311.concat(field312)).then(
      () => dispatch(setValidity({ group: 'businessPlan', value: true })),
      () => dispatch(setValidity({ group: 'businessPlan', value: false }))
    );
  }, [carrier]);

  return (
    <div className={styles.subTabPlan1} style={{ minHeight: 1200 }}>
      <Form
        form={form}
        initialValues={{}}
        trigger="onChange"
        className={styles.subTabPlan1Form}
      >
        <Row>
          <div className="d-flex justify-content-between w-100">
            <Col span={10} className="busPlanCol1">
              <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
                Στοιχεία Επενδυτικού Σχεδίου
              </p>
              <Row>
                {formFields311.map((field, index) => (
                  <Col key={index} className="gutter-row" span={field.span}>
                    <Form.Item
                      name={field.name}
                      value={renderFieldValue1(field)}
                      validateFirst
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                      rules={field.rules}
                    >
                      <FormField
                        {...omit(field, ['span', 'rules'])}
                        key={index}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                ))}
                <div className="d-flex justify-content-between w-100">
                  {formFields3111.map((field, index) => (
                    <Col key={index} className="gutter-row" span={field.span}>
                      <Form.Item
                        name={field.name}
                        value={renderFieldValue1(field)}
                        validateFirst
                        onChange={value =>
                          handleChange({
                            key: field.name,
                            type: field.type,
                            event: value,
                          })
                        }
                        rules={field.rules}
                      >
                        <FormField
                          {...omit(field, ['span', 'rules'])}
                          key={index}
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ))}
                </div>
                {formFields3112.map((field, index) => (
                  <Col key={index} className="gutter-row" span={field.span}>
                    <Form.Item
                      name={field.name}
                      value={renderFieldValue1(field)}
                      validateFirst
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                      rules={field.rules}
                    >
                      <FormField
                        {...omit(field, ['span', 'rules'])}
                        key={index}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col span={11} className="">
              <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
                Τόπος Εκτέλεσης Επενδυτικού Σχεδίου
              </p>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                {formFields312.map((field, index) => (
                  <Col key={index} className="gutter-row" span={field.span}>
                    <Form.Item
                      name={field.name}
                      value={renderFieldValue2(field)}
                      validateFirst
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                      rules={field.rules}
                    >
                      <FormField
                        {...omit(field, ['span', 'rules'])}
                        key={index}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                ))}
              </Row>
            </Col>
          </div>
        </Row>
      </Form>
    </div>
  );
};

export default SubTabPlan1;
